import React, { useState, useEffect } from "react";
//import { confirm } from "react-confirm-box";
import axios from 'axios';
import {Link, NavLink } from "react-router-dom";
import { useLocation } from "react-router";
import $ from 'jquery';
import saveAs from 'file-saver';
import { useNavigate } from 'react-router-dom'
import {Buffer} from 'buffer';
import { decode as atob } from 'base-64';

//var dateFormat = require('dateformat');


const RenderWpForm = () => {
var md5 = require('md5');
const customspremurl=sessionStorage.getItem("CUSTOMSPREMURL");
const resturl=sessionStorage.getItem("RESTURL");	
//const resturl='https://borderforceapps.gov.tc/';

//var boolFetchingSads=false;

const navigate = useNavigate();

const [wptapp, setWptapp] = useState({WORK_PERMIT_ID:0, RETURN_CLICKED:false, SUBMIT_FORM:false, PHOTO:"", SIGNAT:""});
const [searchcrit, setSearchcrit] = useState({txt:"", dates: "", appstatus:"", apptype:"", filteruser:""});
const [selectedFiles, setSelectedFiles] = useState([]);

const [dowait, setDowait] = useState({show:false});
const [dowaittbl, setDowaittbl] = useState({show:false});
/*
const [updateflds, setUpdateflds] = useState({
dated_as:0
,deleted:0
});

*/

const [city, setCity] = useState({name:""});


const [tblendorsee, setTblendorsee] = useState([]);
const [combolocation, setCombolocation] = useState([]);
const [combocategory, setCombocategory] = useState([]);
const [combotype, setCombotype] = useState([]);

const [tblwptprocess, setTblwptprocess] = useState([]);
const [wptprocstatus, setWptprocstatus] = useState([]);



const [comboprocessarea, setComboprocessarea] = useState([]);

const [progress, setProgress] = useState({
perct:null
});


const location = useLocation();
const AD_USER=sessionStorage.getItem("AD_USER")?sessionStorage.getItem("AD_USER"):"";

useEffect(() => {
	
if (sessionStorage.getItem("USERNAME")==null || sessionStorage.getItem("USERNAME")=="null" || sessionStorage.getItem("USERNAME")==undefined || sessionStorage.getItem("USERNAME")==""){
	navigate("/");
	return;
	}//end if	

if (AD_USER==""){
	navigate("/dashboard");
	return;
	}//end if	
	
document.title =   "APS Work Permits";	
/*
179207
108763
*/
console.log("location.state: "+location.state);
getwptprocstatus();


 },[]);


useEffect(() => {
/*
wptprocstatus is the trigger for getwptprocstatus(); completion
getwptprocstatus(); is the first useEffect on page load 
*/
	
	console.log("wptprocstatus.length: "+wptprocstatus.length);
	console.log("location.state: "+location.state);
	//console.log("wptprocstatus.length: "+wptprocstatus.length);
	
	if (wptprocstatus.length>0){
			let WORK_PERMIT_ID=0;
			if (location.state)
				if (location.state.WORK_PERMIT_ID)
					WORK_PERMIT_ID = location.state.WORK_PERMIT_ID;
			
			console.log("WORK_PERMIT_ID: "+WORK_PERMIT_ID);
			
			if (WORK_PERMIT_ID>0)
				setWptapp((prev)=>{
					return {...prev, WORK_PERMIT_ID:WORK_PERMIT_ID }
				});
			else
				gettblwptprocess();
	}
	
		
/*
wptprocstatus is the trigger for getwptprocstatus(); completion
getwptprocstatus(); is the first useEffect on page load 
*/
},[JSON.stringify(wptprocstatus)]);



useEffect(() => {
	
const visibility=wptapp.STATUS=="APPROVED"?"visible":"hidden";
if (document.getElementById("btnwpletter"))
	document.getElementById("btnwpletter").style.visibility=visibility;
document.getElementById("btnletter").style.visibility=visibility;


 },[wptapp.STATUS]);


useEffect(() => {

if (wptapp.CREATED_DATE)
	tbl_wptapp_endorsee();

 },[wptapp.CREATED_DATE]);

	

useEffect(() => {
	
	if (wptapp.SUBMIT_FORM==true)
		submitform1(null);

 },[wptapp.SUBMIT_FORM]);



 
useEffect(() => {
	
	if (wptprocstatus.length>0)
		gettblwptprocess();

 },[searchcrit]);

useEffect(() => {

//console.log("tblwptprocess.length: "+tblwptprocess.length);

if (tblwptprocess.length>0){
	openCity(null, "tblwptprocess");
	}
	
	

 },[JSON.stringify(tblwptprocess)]);




useEffect(() => {


console.log("wptapp.WORK_PERMIT_ID: "+wptapp.WORK_PERMIT_ID);


if (wptapp.WORK_PERMIT_ID>0){
	getwptprocess();
	}
else{
	let LBR_CLR_APP_ID=0, WPT_APP_ID=0;
	if (location.state){
		if (location.state.LBR_CLR_APP_ID)
			LBR_CLR_APP_ID=location.state.LBR_CLR_APP_ID;
		if (location.state.WPT_APP_ID)
			WPT_APP_ID=location.state.WPT_APP_ID;
		
		}//end if
		
	console.log("LBR_CLR_APP_ID: "+LBR_CLR_APP_ID);
	//if (LBR_CLR_APP_ID>0 && wptapp.RETURN_CLICKED==true){
	if (wptapp.RETURN_CLICKED==true){
		let path="lbr_clr_app";
		if (location.state)
			if (location.state.returnpg)
				path=location.state.returnpg.path;
		
		console.log("nav to path: "+path);
		navigate("/"+path, {state:{LBR_CLR_APP_ID:LBR_CLR_APP_ID, WPT_APP_ID:WPT_APP_ID}})
		}
	else
		openCity(null, "tblwptprocess");
	}//end else


 },[wptapp.WORK_PERMIT_ID]);



function openCity(evt, cityName) {
	
	console.log("openCity: "+cityName);
	
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  if (document.getElementById(cityName))
	document.getElementById(cityName).style.display = "block";

/*
	if (evt.currentTarget)
		evt.currentTarget.className += " active";
*/
	if (cityName=="tblwptprocess" && document.getElementsByName("txt")[0])
		document.getElementsByName("txt")[0].focus();
	
  setCity({name:cityName});
}//end func


async function getwptprocstatus(){

console.log('getwpformoptions ');

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {} )
  };		

setDowait({show:true});
setWptprocstatus([]);

  await fetch(resturl+'rarwptprocess/getwptprocessoptions',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptprocstatus(res) )	

  


}//end func

function aftergetwptprocstatus(res){
	setDowait({show:false});
	
if (!res.length)
	return;

let templocation=[], tempcombotype=[];
let tempwptprocstatus=[], tempcombocateg=[];

res.map((col, index) => {
	const combo=col['COMBO'];
	const key=combo+"_"+index;
	const key2=combo+"_"+index+"_2";
	const opt=col['OPT'];
	const val=col['VAL'];
	const strOption=""+opt;

	if (combo=='location' && !strOption.toUpperCase().includes("UNKNOWN"))
		templocation.push(<option key={key} value={opt}  >{opt}</option>);
	else if (combo=='status')
		tempwptprocstatus.push(<option key={key} value={opt}  >{opt}</option>);
	else if (combo=='wptype')
		tempcombotype.push(<option key={key} value={opt}  >{opt}</option>);
	else if (combo=='category')
		tempcombocateg.push(<option key={key} value={opt}  >{opt}</option>);
	
	});//end map
setCombolocation(templocation);
setWptprocstatus(tempwptprocstatus);	

setCombocategory(tempcombocateg);	
setCombotype(tempcombotype);	

	
}//end func


async function tbl_wptapp_endorsee(){

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WPT_APP_ID:"", WORK_PERMIT_ID:wptapp.WORK_PERMIT_ID} )
  };		


  await fetch(resturl+'rarwptprocess/tbl_wptapp_endorsee',requestOptions)
      .then(res => res.json())
      .then(res => 	after_tbl_wptapp_endorsee(res) )
      .catch(err => console.log(err));

}//end func

function after_tbl_wptapp_endorsee(res){
	
if (!res.length)
	return;

let htmrows=[];

	res.map((col, index) => {
		
		const key="tblendorc_"+index;
		const endorsee_id=col['endorsee_id'];
		//const openLink=<a href="#" className="nodecor" target="_blank" onClick={(e)=>{openWptprocess(e, WORK_PERMIT_ID);}} ><img src='img/folderyel.png' height='18' border='0' />&nbsp;{MPE_NAME}</a>;
	
		const htmrow=<tr key={key} >
					<td align="right" >{col['ENDORSEE_ID']}</td>
					<td align="left" >{col['NAME']}</td>
					<td align="left" >{col['GENDER']}</td>
					<td align="left" >{col['NATIONALITY']}</td>
					<td align="left" >{col['DECISION']}</td>
					</tr>;
		htmrows.push(htmrow);
		


		});//end map

setTblendorsee(htmrows);
}//end func

async function gettblwptprocess(){
const EMAIL=sessionStorage.getItem("EMAIL");
console.log('EMAIL: '+EMAIL);
const USERNAME=sessionStorage.getItem("USERNAME")==undefined?sessionStorage.getItem("EMAIL"):sessionStorage.getItem("USERNAME");


const params={
	USERNAME:USERNAME
, crit:searchcrit
, DATES: searchcrit.dates
}

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

setDowaittbl({show:true});
setTblwptprocess([]);

  await fetch(resturl+'rarwptprocess/gettblwptprocess',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergettblwptprocess(res) )
      .catch(err => console.log(err));

}//end func

function openWptprocess(e, WORK_PERMIT_ID){
	
	console.log("openWptprocess WORK_PERMIT_ID: "+WORK_PERMIT_ID);
	
	e.preventDefault();
	setWptapp((prev)=>{
		return {...prev, WORK_PERMIT_ID:WORK_PERMIT_ID}
	});
	
}//end func

function aftergettblwptprocess(res){
	
	console.log("aftergettblwptprocess res.length: "+res.length);
	
	setDowaittbl({show:false});
	
if (!res.length)
	return;

let htmrows=[];

	res.map((col, index) => {
		
		const key="tblwptproc_"+index;
		const WORK_PERMIT_ID=col['WORK_PERMIT_ID'];
		const MPE_NAME=col['MPE_NAME'];
		const openLink=<a href="#" className="nodecor" target="_blank" onClick={(e)=>{openWptprocess(e, WORK_PERMIT_ID);}} ><img src='img/folderyel.png' height='18' border='0' />&nbsp;{MPE_NAME}</a>;
	
		const htmrow=<tr key={key} >
					<td align="right" >{index+1}</td>
					<td align="right" >{col['WORK_PERMIT_ID']}</td>
					<td align="left" >{col['CREATED_DATE']}</td>
					<td align="left" >{col['WORK_PERMIT_NO']}</td>
					<td align="left" >{openLink}</td>
					<td align="left" >{col['APP_TYPE']}</td>
					<td align="left" >{col['STATUS']}</td>
					<td align="left" >{col['OCCUPATION']}</td>
					<td align="left" >{col['EXPIRE_DATE']}</td>
					<td align="left" >{col['EMPLOYER']}</td>
					</tr>;
		htmrows.push(htmrow);
		
		});//end map

setTblwptprocess(htmrows);
	
}//end func

async function getwptphotoandsignat(){


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WORK_PERMIT_ID:wptapp.WORK_PERMIT_ID} )
  };		

  //setDowait({show:true});
	
  await fetch(customspremurl+'rarmssql/getwptphotoandsignat',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptphotoandsignat(res) )
      .catch(err => console.log(err));

}//end func


function aftergetwptphotoandsignat(res){
	
	//setDowait({show:false});
	
	setWptapp((prev)=>{
		return {...prev
			, SIGNAT:res[0].signat
			, PHOTO:res[0].foto
			};
		});
}//end func
	
	
async function getwptprocess(){


   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {USERNAME:sessionStorage.getItem("USERNAME"), WORK_PERMIT_ID:wptapp.WORK_PERMIT_ID} )
  };		

setDowait({show:true});

  await fetch(resturl+'rarwptprocess/getwptprocess',requestOptions)
      .then(res => res.json())
      .then(res => 	aftergetwptprocess(res) )
      .catch(err => console.log(err));

}//end func


function aftergetwptprocess(res){

setDowait({show:false});

let datas=wptapp;

for(var attributename in res[0]){
	if ( attributename!="PHOTO_FILE" && attributename!="SIGNA_FILE" ){
		const data=res[0][attributename];
		datas[attributename] = (data==null)?'':data;
		
		}//end if
	}//end for	
	
	//setWptapp(datas);
//console.log("aftergetwptprocess: "+JSON.stringify(datas));

const CREATED_DATE=datas.CREATED_DATE??"";
	
console.log("CREATED_DATE: "+CREATED_DATE);	
if (CREATED_DATE==""){
	//flags that the WP record is not inserted
	insertlocalworkpermit();
	return;
	}//end if

setWptapp((prev)=>{
	return {...prev, datas}
});
getwptphotoandsignat();
openCity(null, "currwptprocess");

}//end func

async function insertlocalworkpermit(){
	
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WPT_APP_ID:location.state.WPT_APP_ID, WORK_PERMIT_ID:wptapp.WORK_PERMIT_ID} )
  };		
  
  setDowait({show:true});

  await fetch(resturl+'rarwptprocess/insertlocalworkpermit',requestOptions)
      .then(res => res.json())
      .then(res => 	afterinsertlocalworkpermit(res) )
      .catch(err => console.log(err));	
	
}//end func

function afterinsertlocalworkpermit(res){
	
	setDowait({show:false});
	
	let CREATED_DATE="";
	
	if (res.length)
		if (res[0].CREATED_DATE)
			CREATED_DATE=res[0].CREATED_DATE;
	
	if (CREATED_DATE=="")
		showsnackbar("no CREATED_DATE.  insert local workpermit failed");
	else
		getwptprocess();
		
}//end func

async function calluploadmpefoto(e){
/*
would like to keep a copy on APS disk but not worth it now since the signature still is missing.
for now just update prem only

*/
e.preventDefault();
if (!e.target.classList.contains("hidden"))
	e.target.classList.add("hidden");

const photo_img=document.getElementById('photo_img');
await fetch(photo_img.src)
.then(res => res.blob())
.then(blob => {
	console.log("blob.length: "+blob.length);
	//2025-08-24 b4 we were sending a image loaded on the page, now we are sending from SelectedFiles
   //const photo_file = new File([blob], wptapp.WORK_PERMIT_ID+'.png', blob);
	const photo_file=selectedFiles[0].file;
	var r = new FileReader();
	r.onload = function(){ uploadmpefoto(e, r.result.split(',')[1] ) };
	r.readAsDataURL(photo_file);
	});
	
}//end func

async function uploadmpefoto(e, str64foto){

console.log(" str64foto.length: "+str64foto.length);

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {work_permit_id:wptapp.WORK_PERMIT_ID, str64foto:str64foto, updated_by:sessionStorage.getItem("USERNAME")} )
  };		

await fetch(customspremurl+'rarmssql/uploadmpefoto',requestOptions)
  .then(res => res.json())
  .then(res => 	afteruploadmpefoto(res, e) )
  .catch(err => console.log(err));	
	
}//end func

function afteruploadmpefoto(res, e){
if (e.target.classList.contains("hidden"))
	e.target.classList.remove("hidden");

let update_count=0;

if (res.length)
	if (res[0].update_count)
		update_count=res[0].update_count;

if (update_count>0)	
	showsnackbar("update is complete!");	
else
	showsnackbar("something went wrong");	

}//end func

async function callupdatempesignat(e){
e.preventDefault();
if (!e.target.classList.contains("hidden"))
	e.target.classList.add("hidden");

const signat_img=document.getElementById('signat_img');
await fetch(signat_img.src)
.then(res => res.blob())
.then(blob => {
	console.log("blob.length: "+blob.length);
	//2025-08-24 b4 we were sending a image loaded on the page, now we are sending from SelectedFiles
   //const signat_file = new File([blob], wptapp.WORK_PERMIT_ID+'.png', blob);
   const signat_file=selectedFiles[0].file;
   
   var r = new FileReader();
	r.onload = function(){ updatempesignat(e, r.result.split(',')[1] ) };
	r.readAsDataURL(signat_file);
	});
	

	
}//end func

async function updatempesignat(e, str64signat){
 
   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {work_permit_id:wptapp.WORK_PERMIT_ID, str64signat:str64signat, updated_by:sessionStorage.getItem("USERNAME")} )
  };	

await fetch(customspremurl+'rarmssql/updatempesignat',requestOptions)
  .then(res => res.json())
  .then(res => 	afterupdatempesignat(res, e) )
  .catch(err => console.log(err));	
  
}//end func


function afterupdatempesignat(res, e){
if (e.target.classList.contains("hidden"))
	e.target.classList.remove("hidden");

let update_count=0;

if (res.length)
	if (res[0].update_count)
		update_count=res[0].update_count;

if (update_count>0)	
	showsnackbar("update is complete!");	
else
	showsnackbar("something went wrong");	

}//end func

async function updateworkpermit(){
	
//const formData = new FormData();

let params={username:sessionStorage.getItem("USERNAME")};

const arrCol="work_permit_id,status,concern,category,location,app_type,occupation,date_issue,expire_date,work_permit_no,first_name,last_name,full_name,employer,dob,gender,nationality,card_no,created_date,created_by,updated_date,updated_by,deleted".split(",");

for (var i=0; i<arrCol.length; i++){
	const col = arrCol[i].trim();
	params[col] = wptapp[col.toUpperCase()];
	}//end for

   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };	

console.log("will fetch to updateworkpermit");

  await fetch(customspremurl+'rarmssql/updateworkpermit',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdateworkpermit(res) )
      .catch(err => console.log(err));

}//end func


function afterupdateworkpermit(res){
	getwptprocess();
}//end func


async function createBlobFromFile(file){
	
    //const file = await fs.readFile(path, function (err, data) { 	});
	 return new Blob([file]);
   
}//end func



function handleFocus(e){
	e.target.select();
}

function handleChange(e){
	
	showBtnsave();
	
	const {name, value}=e.target;
//console.log("handleChange name: "+name+" -> "+value);	
//document.getElementById('btnsave').style.visibility='visible';
setWptapp((prev)=>{
	return {...prev, [name]:value}
});


}//end func

function toggleModalsm() {
const modalsm = document.querySelector(".modalsm");

	
console.log('modalsm is null: '+(modalsm==null));
modalsm.classList.toggle("show-modalsm");

if (document.querySelector(".close-button")){
	const closeButton = document.querySelector(".close-button");
	if(!closeButton.classList.contains('attached-listener')){
		closeButton.classList.add('attached-listener');
		closeButton.addEventListener("click", toggleModalsm);
		window.addEventListener("click", windowOnClick);
		}//end if
	}//end if
return false;
}//end func

function showsnackbar(innerHTML) {
  var x = document.getElementById("snackbar");
  x.innerHTML=innerHTML;
  x.className = "show";
  setTimeout(function(){ x.className = x.className.replace("show", ""); }, 5000);
}//end func

function windowOnClick(event) {
const modalsm = document.querySelector(".modalsm");
	
console.log('event.target === modalsm: '+(event.target === modalsm));
	
    if (event.target === modalsm) {
    	toggleModalsm();
    }
}//end func




async function rptwptcardxml(e) {
	if (e)
		e.preventDefault();
	
	if (wptapp.STATUS!="APPROVED"){
		window.alert("It must be approved");
		return;
		}	
	
	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, WORK_PERMIT_ID: wptapp.WORK_PERMIT_ID
		};
	//{  }
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

	if (e.target)
		e.target.style.visibility='hidden';


  await fetch(resturl+'rarwptprocess/rptwptcardxml',requestOptions)
      .then(res => 	afterrptwptcardxml(res, e) )
      .catch(err => console.log(err));
	  
}//end func

async function afterrptwptcardxml(res, e){
	//application/vnd.openxmlformats-officedocument.wordprocessingml.document
	const filename="WorkPermitCardLetter"+wptapp.WORK_PERMIT_NO+".docx";
	const blob = await res.blob();
	saveAs(blob, filename);
	if (e.target)
		e.target.style.visibility='visible';
	
}//end func


async function preprunireportext(e) {
	if (e)
		e.preventDefault();
	
	if (wptapp.STATUS!="APPROVED"){
		window.alert("It must be approved");
		return;
		}
	
	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, PNAM: "WORK_PERMIT_ID"
		, PVAL: wptapp.WORK_PERMIT_ID
		, JASPER_FILE_NAME: "WorkPermitGeneralCover.jasper"
		, EXECUTEQUERY: ""
		, CALLABLESTATEMENT: " CALL BFADM.SP_RPT_WORK_PERMIT_COVER("+wptapp.WORK_PERMIT_ID+" , ~); "
		};
	//{  }
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

	if (e.target)
		e.target.style.visibility='hidden';


  await fetch(resturl+'rarwptprocess/preprunireportext',requestOptions)
      .then(res => 	afterpreprunireportext(res, e) )
      .catch(err => console.log(err));
	  
}//end func

async function afterpreprunireportext(res, e){
	const filename="WorkPermitGeneralCover"+wptapp.WORK_PERMIT_ID+".pdf";
	const blob = await res.blob();
	saveAs(blob, filename);
	if (e.target)
		e.target.style.visibility='visible';
	
}//end func

async function savedatedas(e){
	if (e)
		e.preventDefault();
	
	const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( {WORK_PERMIT_ID:wptapp.WORK_PERMIT_ID, DELETED:wptapp.DELETED, DATED_AS:wptapp.DATED_AS} )
  };		

  await fetch(resturl+'rarwptprocess/savedatedas',requestOptions)
      .then(res => res.json())
      .then(res => 	aftersavedatedas(res) )
      .catch(err => console.log(err));
	  
}//end func

function aftersavedatedas(res){

let UPDATE_COUNT=0;
if (res.length)
	if (res[0].UPDATE_COUNT)
		UPDATE_COUNT=res[0].UPDATE_COUNT;

if (UPDATE_COUNT>0){
	//339337 24.Jul.2025 03:36 PM
	setWptapp((prev)=>{
		return {
			...prev
			, DELETED: res[0].DELETED
			, DATED_AS: res[0].DATED_AS
			, CREATED_BY: res[0].CREATED_BY
			, TC_CREATED_DATE: res[0].TC_CREATED_DATE
			, UPDATED_BY: res[0].UPDATED_BY
			, TC_UPDATED_DATE: res[0].TC_UPDATED_DATE
			}
		});
	
	}//end if
else
	showsnackbar("something went wrong.  please try again");



}//end func

async function submitform1(e) {
	if (e)
		e.preventDefault();
	
	let temp={WORK_PERMIT_ID:wptapp.WORK_PERMIT_ID};
	const arrCol="FIRST_NAME, LAST_NAME, EMPLOYER, DOB, GENDER, PASSPORT_NO, OCCUPATION, CATEGORY, LOCATION, CARD_NO, BOARD_REMARKS, CONCERN, STATUS, DATE_ISSUE, EXPIRE_DATE, APP_TYPE, SPOUSE, CHILD".split(",");
	for (var i=0; i<arrCol.length; i++){
		const col = arrCol[i].trim();
		temp[col] = wptapp[col];
		}
	
	const params={
		USERNAME:sessionStorage.getItem("USERNAME")
		, wptapp: temp
		};
	
	   const requestOptions = {
      method: 'POST'
	  ,headers: { 'Content-Type': 'application/json' }
	  ,body: JSON.stringify( params )
  };		

  await fetch(resturl+'rarwptprocess/updatewptprocess',requestOptions)
      .then(res => res.json())
      .then(res => 	afterupdatewptprocess(res) )
      .catch(err => console.log(err));
	  
}//end func


function afterupdatewptprocess(res){
	
	console.log(JSON.stringify(res));
	
	let UPDATE_COUNT=0;
	
	if (res.length)
		if (res.length>0)
			UPDATE_COUNT=res[0].UPDATE_COUNT;
	
	if (UPDATE_COUNT>0){
		showsnackbar("# of rows updated: "+UPDATE_COUNT);
		updateworkpermit();
		}
	else
		showsnackbar("something went wrong.  please try again");
}//end func

function critChange(e){
		var {name, value}=e.target;
//console.log("handleChange name: "+name+" -> "+value);	
//document.getElementById('btnsave').style.visibility='visible';
if (name=="filteruser")
	value=(e.target.checked)?value:"";

setSearchcrit((prev)=>{
	return {...prev, [name]:value}
});


}//end func

function showBtnsave(){
	//console.log("showBtnsave 1");
	
	if (document.getElementById('btnsave')){
		//console.log("showBtnsave 2");
		document.getElementById('btnsave').style.visibility="visible";
		}
}//end func




function backPage(e){
e.preventDefault(); 

const BACK_PAGE=location.state?(location.state.BACK_PAGE??""):"";

console.log("BACK_PAGE: "+BACK_PAGE);

if (BACK_PAGE==""){
setWptapp((prev)=>{
	return {...prev, WORK_PERMIT_ID:0, RETURN_CLICKED:true}
	});
	//openCity(null, "tbllaborclr");
	//document.getElementById("tblmain").scrollIntoView();
	}//end if
else
	navigate("/"+BACK_PAGE, {state:{WPT_APP_ID:wptapp.WPT_APP_ID??0, WORK_PERMIT_ID:wptapp.WORK_PERMIT_ID??0}});
	
}//end func


function writeClipboard(e, text1){
if (e)
	e.preventDefault();
/* var  text1= "Example text to appear on clipboard"; */
navigator.clipboard.writeText(text1).then(function() {
  //console.log('Async: Copying to clipboard was successful!');
  showsnackbar(text1+" was copied to clipboard");
}, function(err) {
  console.error('Async: Could not copy text: ', err);
});	
	
}//end func



function nextCardNoOld(e){
	e.preventDefault();
	const result=window.confirm("are you sure you want to use the next card no in sequence?");
	if (result){
		setWptapp((prev)=>{
			return {...prev, CARD_NO:wptapp.NEXT_CARD_NO, SUBMIT_FORM:true}
			});
		
		}//end func
}//end func






function selectedFilesChange(event){

const elemName=event.target.name;	
console.log('selectedFilesChange elemName: '+elemName);

if (event.target.files.length>1){
	showsnackbar("upload only one file please");
	return;
	}
else if (event.target.files.length==0)
	return;
	
const fileName=event.target.files[0].name;
console.log('fileName: '+fileName);
var fileExtension = "";
if (fileName.lastIndexOf(".") > 0) 
	fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length);

const lsExtension="png";
if (!(", "+lsExtension).includes(", "+fileExtension)){
	document.getElementsByName(elemName)[0].value='';
	showsnackbar("error: the uploaded file must have one of these extensions: "+lsExtension);
	return;
	}//end if		

if (elemName=="photo_file" && document.getElementById("btn_photo_file"))
	if (document.getElementById("btn_photo_file").classList.contains("hidden"))
		document.getElementById("btn_photo_file").classList.remove("hidden");

if (elemName=="signat_file" && document.getElementById("btn_signat_file"))
	if (document.getElementById("btn_signat_file").classList.contains("hidden"))
		document.getElementById("btn_signat_file").classList.remove("hidden");

//if (selectedFiles.length==0)
	//addSubmitEventListener('form1', subEvtLsrCallback);
const i=0;//selectedFiles.length
//console.log('selectedFiles.length: '+i);
const uploadFileName=elemName=="photo_file"?wptapp.WORK_PERMIT_ID+".png":wptapp.WORK_PERMIT_ID+".png";
let temp=selectedFiles;
temp[i]={file:event.target.files[0], name:uploadFileName, ext:fileExtension};
setSelectedFiles((prev)=>{
	return [...temp]/*return [...prev, ...temp]*/
});

}//end func

function updatefldsChangeOld(e){
const {name, value}=e.target;

/*
setUpdateflds((prev)=>{
	return {...prev, [name]:value}
	});
*/

}//end func

{/*
<input name='STATUS' value={wptapp.STATUS} onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{handleFocus(e);}} autoComplete='off' />
*/}

let returntitle="return to Work Permit List";
if (location.state)
	if (location.state.returnpg)
		returntitle="return to "+location.state.returnpg.name;
			
const tblfields=<>
	<form id='form1' method='POST' onSubmit={(e)=>{submitform1(e);}} >
	<table align='center' border="0" width="100%"  >
	<tbody  >
	<tr>
		<td align='right' >Status:</td>
		<td align='left' >
			{
				wptapp.USER_CAN_APPROVE>0 && 
				<select name="STATUS" value={wptapp.STATUS} onChange={(e)=>{handleChange(e);}} >
				{wptprocstatus}
				</select>
			}
			{
				wptapp.USER_CAN_APPROVE==0 && 
				<input name="STATUS" value={wptapp.STATUS} readOnly className="gnsbro" />
			}
			&nbsp;&nbsp;
			<a href="#" id="btnletter" title="download pdf letter" onClick={(e)=>{preprunireportext(e);}} ><img src="img/printer.png" height="18" border="0"  /></a>
			{/*
			&nbsp;&nbsp;
			<a href="#" id="btnwpletter" title="download work permit letter" onClick={(e)=>{rptwptcardxml(e);}} ><img src="img/msword.png" height="18" border="0"  /></a>
			*/}
			
		</td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Fees:</td>
		<td align='left' >
			<input name='FEES' value={wptapp.FEES} size="7" onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{handleFocus(e);}} autoComplete='off' />
				{/*<a href="#" onClick={(e)=>{getwptprocess();}}  className="nodecor" title="reload this form" ><img src="img/refresh.png" border="0" /> reload form</a>*/}
		</td>
	</tr>
	<tr>
		<td align='right' >Work Permit #:</td>
		<td align='left' ><input name='WORK_PERMIT_NO' defaultValue={wptapp.WORK_PERMIT_NO} readOnly className="gnsbro"  onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Penalties:</td>
		<td align='left' ><input name='PENALTY_FEE' value={wptapp.PENALTY_FEE}  size="7" onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
	</tr>

	<tr>
		<td align='right' >First Name:</td>
		<td align='left' ><input name='FIRST_NAME' defaultValue={wptapp.FIRST_NAME} readOnly className="gnsbro"  onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Location:</td>
		<td align='left' >
			
			<select name="LOCATION" value={wptapp.LOCATION} onChange={(e)=>{handleChange(e);}} >
			{combolocation}
			</select>
		</td>
	</tr>

	<tr>
		<td align='right' >Last Name:</td>
		<td align='left' ><input name='LAST_NAME' defaultValue={wptapp.LAST_NAME} readOnly className="gnsbro"  onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >App. Type:</td>
		<td align='left' >
			<select  name='APP_TYPE' value={wptapp.APP_TYPE} onChange={(e)=>{handleChange(e);}} >
			<option value='' ></option>
			{combotype}
			</select>
			
		</td>
	</tr>
	<tr>
		<td align='right' >Date of Birth:</td>
		<td align='left' ><input name='DOB' defaultValue={wptapp.DOB} type='date' readOnly className="gnsbro"  onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Issue Date:</td>
		<td align='left' ><input name='DATE_ISSUE' value={wptapp.DATE_ISSUE} type='date' onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
	</tr>
	<tr>
		<td align='right' >Gender:</td>
		<td align='left' ><input name='GENDER' defaultValue={wptapp.GENDER} readOnly className="gnsbro" onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Expire Date:</td>
		<td align='left' ><input name='EXPIRE_DATE' value={wptapp.EXPIRE_DATE} type='date' onChange={(e)=>{handleChange(e);}} onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
	</tr>
	<tr>
		<td align='right' >Country:</td>
		<td align='left' ><input name='COUNTRY' defaultValue={wptapp.COUNTRY} readOnly className="gnsbro" onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Category:</td>
		<td align='left' >
			<select  name='CATEGORY' value={wptapp.CATEGORY} onChange={(e)=>{handleChange(e);}} >
			<option value='' ></option>
			{combocategory}
			</select>
		</td>
	
	</tr>

	<tr>
		<td align='right' >Nationality:</td>
		<td align='left' ><input name='NATIONALITY' defaultValue={wptapp.NATIONALITY} readOnly className="gnsbro" onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Spouse:</td>
		<td align='left' >
			<input name='SPOUSE' value={wptapp.SPOUSE} size="3"  readOnly className="gnsbro" style={{textAlign:"center"}} onFocus={(e)=>{handleFocus(e);}} autoComplete='off' />
			&nbsp;&nbsp;Child:
			<input name='CHILD' value={wptapp.CHILD} size="3"  readOnly className="gnsbro" style={{textAlign:"center"}} onFocus={(e)=>{handleFocus(e);}} autoComplete='off' />
		</td>
	</tr>
	<tr>
		<td align='right' >Passport #:</td>
		<td align='left' ><input name='PASSPORT_NO' defaultValue={wptapp.PASSPORT_NO} readOnly className="gnsbro"  onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Occupation:</td>
		<td align='left' ><input name='OCCUPATION' defaultValue={wptapp.OCCUPATION} readOnly className="gnsbro" onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
	</tr>


	<tr>
		<td align='right' >Employer:</td>
		<td align='left' ><input name='EMPLOYER' defaultValue={wptapp.EMPLOYER} readOnly className="gnsbro" onFocus={(e)=>{handleFocus(e);}} autoComplete='off' /></td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Card #:</td>
		<td align='left' >
			<input name="CARD_NO" value={wptapp.CARD_NO?? ""} type='text' size="7" onChange={(e)=>{handleChange(e);}}  onFocus={(e)=>{handleFocus(e);}} autoComplete='off'  />
			
				{/*&nbsp;&nbsp;<a href="#" title="use next card no" className="nodecor"  onClick={(e)=>{ nextCardNo(e);}} >{wptapp.NEXT_CARD_NO}</a>*/}
		</td> 
	</tr>

	<tr>
		<td align='right' >Create Date:</td>
		<td align='left' >{wptapp.TC_CREATED_DATE}</td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Update Date:</td>
		<td align='left' >{wptapp.TC_UPDATED_DATE}</td>
	</tr>
	<tr>
		<td align='right' >Create User:</td>
		<td align='left' >{wptapp.CREATED_BY}</td>
		<td align='center' width="20" >&nbsp;</td>
		<td align='right' >Update User:</td>
		<td align='left' >{wptapp.UPDATED_BY}</td>
	</tr>

	<tr>
		<td align='right' >&nbsp;</td>
		<td align='left' >&nbsp;</td>
		<td align='center' width="20" ></td>
		<td align='right' ><a href="#" title={returntitle} onClick={(e)=>{ backPage(e); }} ><img src="img/return.png" border="0" /></a></td>
		<td align='left' >&nbsp;&nbsp;
			{dowait.show && <div><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</div>}
			{
			!dowait.show && 
			<button className='button' id='btnsave' style={{visibility:"hidden"}}    >save changes</button>
			}			
		
		</td>
	</tr>
	
	
	<tr>
		<td align='right' >Concerns:</td>
		<td align='left' colSpan="2" >
		<textarea name="CONCERN" value={wptapp.CONCERN} onChange={(e)=>{handleChange(e);}} cols="35" rows="5" ></textarea>
		</td>

		<td align='center' colSpan="2" >
		<table align='center' className="customers" >
		<tbody>
		<tr>
			<th align="center">Id</th>
			<th align="left">Edorsee's Name</th>
			<th align="left">Gender</th>
			<th align="left">National.</th>
			<th align="left">Approv.</th>
		</tr>
		</tbody>

		<tbody>
		{tblendorsee}
		</tbody>

		</table>
		</td>		
		
		
		{/*<td align='center' width="20" >&nbsp;</td>	*/}
	</tr>


	</tbody>
	</table>
	</form>
	</>;


const username=sessionStorage.getItem("USERNAME");
	
	{/*marginBottom:"6px", marginTop:"9px"*/}
	
  return (
    <>
	

<div id="tblwptprocess" className="tabcontent">
  <h4 align='center' className="Acme" style={{ marginBottom:"4px", color:"brown",fontSize:"22px"}} >
  Process Work Permit Applications
  </h4>
  <div align="center" style={{ marginTop:"9px", marginBottom:"9px" }} >
	search criteria: <input name="txt" value={searchcrit.txt} onChange={(e)=>{critChange(e);}} size="35" style={{textAlign:"center"}} placeholder="ref#, passort, employer name, worker name"  onFocus={(e)=>{e.target.select();}} />
	&nbsp;&nbsp;
	<input type="checkbox" id="cbfilterme" name="filteruser" value={username} onClick={(e)=>{critChange(e);}} /><label htmlFor="cbfilterme" className="hand" >filter {username}</label>
  </div>
	<table align='center' className='customers'  >
	<thead>
	<tr>
	<th>#</th>
	<th>Work<br/>Pmt. Id</th>
	<th>create<br/>date</th>
	<th>Immigr.<br/>Ref. #</th>
	<th>Employee</th>
	<th>
		<select name="apptype" value={searchcrit.apptype} onChange={(e)=>{critChange(e);}} >
		<option value='' >***Type***</option>
		{combotype}
		</select>
	</th>
	<th>
		<select name="appstatus" value={searchcrit.appstatus} onChange={(e)=>{critChange(e);}} style={{width:"110px"}} >
		<option value='' >***Status***</option> 
		{wptprocstatus}
		</select>
	</th>
	<th>Occupation</th>
	<th>Expire<br/>Date</th>
	<th>Employer</th>
	</tr>
	</thead>
	<tbody>
	
			{dowaittbl.show && <tr><td align="center" colSpan="9" ><img src='img/Loading_2.gif' border='0' height='36' /> . . . please wait</td></tr>}
			{
			!dowaittbl.show && tblwptprocess
			}			

	
		
	</tbody>
	</table>
</div>	
	
	
<div id="currwptprocess" className="tabcontent">

{
	username=="ajonesx" && 
		<form id='form2' method='POST' onSubmit={(e)=>{savedatedas(e);}} >
	<table align='center' border='1'>
	<tbody>
	<tr>
		<td align='right' >dated as:</td>
		<td align='left' ><input name='DATED_AS' type='text' required value={wptapp.DATED_AS} onChange={(e)=>{handleChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}}  /></td>
	</tr>
	<tr>
		<td align='right' >deleted:</td>
		<td align='left' ><input name='DELETED' type='text' required value={wptapp.DELETED}  onChange={(e)=>{handleChange(e);}} autoComplete="off" onFocus={(e)=>{e.target.select();}}  /></td>
	</tr>	
	<tr>
		<td align='right' ></td>
		<td align='left' ><button className="button" >save changes</button></td>
	</tr>	
	</tbody>
	</table>
	</form>
}

	
	<fieldset className="fieldsetlg" style={{width:"85%",marginTop:"12px"}} >
	<legend>
	Work Permit with ID {wptapp.WORK_PERMIT_ID}
	&nbsp;<a href="#" onClick={(e)=>{writeClipboard(e, wptapp.WORK_PERMIT_ID);}} title="click to copy ID" ><img src="img/copy.png" height="18" border="0" /></a>
	</legend>
	
	
	<table align="center" border="0" width="100%" >
	<tbody>
	<tr valign="top" >
	<td>
	{tblfields}
	</td>
	<td width="10" >&nbsp;</td>
	<td style={{ width:"200px"}}>
			{wptapp.WORK_PERMIT_ID>0 && <>
			<img id='photo_img' src={"data:image/png;base64, "+wptapp.PHOTO} border='0' width="180" height="180" />
			<br/><input type="file" name="photo_file" accept=".png" onChange={(e)=>{selectedFilesChange(e);}}  />
			<button className="button hidden" id="btn_photo_file"  onClick={(e)=>{calluploadmpefoto(e);}}>upload head-shot photo</button>
			<br/>
			<img id='signat_img' src={"data:image/png;base64, "+wptapp.SIGNAT} border='0' width="200" />
			<br/><input type="file" name="signat_file" accept=".png" onChange={(e)=>{selectedFilesChange(e);}} />
			<button className="button hidden" id="btn_signat_file"   onClick={(e)=>{callupdatempesignat(e);}}>upload signature</button>
			<br/><br/>
			Approved: {wptapp.TC_APPROVED_DATE}
			<br/><br/>
			Approved By: {wptapp.APPROVED_BY}

				{/*
							<br/><br/>
			<a href="#" onClick={(e)=>{preprunireportext(e);}} className="nodecor" ><img src="img/pdf.gif"  border="0" />&nbsp;generate cover sheet</a>

				*/}
			</>
			}	
	</td>
	</tr>
	</tbody>
	</table>
	</fieldset>
	124
	
	{/*<div>{"wptapp.binary: "+wptapp.binary}</div>*/}


</div>	

<div className="modalsm">
    <div className="modalsm-content">
        <span className="close-button">&times;</span>
        <div  id='modalsmtext' >
		<div align="left" >
		please note the password requirements:
		</div>
		<table align="center">
		<tbody>
		<tr>
			<td align="right" >enter password:</td>
		</tr>
		<tr>
			<td align="right" >re-enter password:</td>
		</tr>
		<tr>
			<td align="right" >&nbsp;</td>
			<td align="left" ><button className="button" id="btnpwd" style={{visibility:"hidden"}}  >save the password</button></td>
		</tr>
		</tbody>
		</table>
		
		</div>
		
    </div>
</div>	


<div id="snackbar">&nbsp;</div>
    
	
	</>
  );
  


};


export default RenderWpForm;